var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerPage',{attrs:{"prefix":_vm.prefix,"title":"Subscription & Billing","doc":_vm.doc}},[_c('Payment',{staticClass:"mb-5"}),_c('YearSelector',{on:{"select":_vm.selectYear}}),_c('List',{staticClass:"my-5",attrs:{"items":_vm.org_invoices}}),_c('Purchases',{staticClass:"my-5",attrs:{"year":_vm.year}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }